// src/api/expert-activity-tracker.api.ts
import api from '../Axios';

// ─── TypeScript Interfaces ───
export interface ActivityStats {
  expertCode: string;
  today: {
    seconds: number;
    formatted: string;
  };
  thisWeek: {
    seconds: number;
    formatted: string;
  };
  // 🟢 Enhanced Stats from DB
  total_orders: number;
  total_chat_minutes: number;
  total_call_minutes: number;
  total_video_minutes: number;
}

export interface ActivityHistoryItem {
  id: string;
  started_at: string;
  ended_at: string | null;
  duration_seconds: number | null;
  running_duration: number | null;
  is_online: boolean;
  trigger_source: string;
}

// ─── API Service ───
export const expertActivityTrackerApi = {
  /**
   * Fetches expert activity statistics.
   * @param expertCode - Unique code for the expert
   * @param filter - Date filter: 'today' | '7days' | '1month' | 'all'
   */
  getStats: async (expertCode: string, filter: string = 'all'): Promise<ActivityStats> => {
    // 🟢 FIXED: passing the filter as a query parameter as required by the backend
    const response = await api.get(`/api/expert-activity-tracker/${expertCode}/stats?filter=${filter}`);
    return response.data;
  },

  /**
   * Fetches the recent online/offline status history.
   * @param expertCode - Unique code for the expert
   * @param limit - Number of history items to return
   */
  getHistory: async (expertCode: string, limit: number = 10): Promise<ActivityHistoryItem[]> => {
    const response = await api.get(`/api/expert-activity-tracker/${expertCode}/history?limit=${limit}`);
    return response.data;
  }
};